<app-card-container class="u-container-lg">
    <app-ui-card [border]="false" margin="false">
        <app-analytics-dashboard></app-analytics-dashboard>
    </app-ui-card>
</app-card-container>
